import { useNavigate, useParams } from "react-router-dom";

import RemoveMeetingReportConfirmationModal from "@app/analytics/components/reports/RemoveMeetingReportConfirmationModal";
import useDeleteReport from "@app/analytics/MeetingReport/hooks/useDeleteReport";
import useMeetingReportUiStore from "@app/analytics/MeetingReport/stores/ui";
import ROUTES from "@app/common/routes";

const RemoveReportConfirmationModal = () => {
  const navigate = useNavigate();

  const { sessionId } = useParams();
  const [dialog, setDialog] = useMeetingReportUiStore((state) => [
    state.dialog,
    state.setDialog,
  ]);

  const closeDialog = () => setDialog(null);

  const { removeReport } = useDeleteReport();

  if (!sessionId) return null;

  const handleRemoveReport = () =>
    removeReport.mutate(sessionId!, {
      onSuccess: () => navigate(ROUTES.MEETING_REPORTS),
      onError: closeDialog,
    });

  return (
    <RemoveMeetingReportConfirmationModal
      loading={removeReport.isPending}
      open={dialog === "remove_report"}
      onClose={closeDialog}
      onConfirm={handleRemoveReport}
    />
  );
};

export default RemoveReportConfirmationModal;
